import apiClient from './apiClient';

export interface ClienteVinculo {
  id: number;
  codigo: string;
  nome: string;
  ativo: boolean;
}

export interface UsuarioSemCliente {
  id: number;
  username: string;
  email: string;
  role: string;
  vinculos_ativos: number;
}

export interface VinculoResponse {
  success: boolean;
  message: string;
  created?: string[];
  already_linked?: string[];
  removed?: number;
}

/**
 * Service para gerenciar vinculos usuario-cliente (Multi-Tenant Isolation)
 * Epic 39 - Isolamento Multi-Tenant por Cliente
 */
const usuarioClienteService = {
  /**
   * Lista clientes vinculados a um usuario
   */
  getClientesUsuario: async (usuarioId: number): Promise<ClienteVinculo[]> => {
    const response = await apiClient.get(`/usuarios/${usuarioId}/clientes`);
    return response.data;
  },

  /**
   * Cria vinculos entre usuario e clientes
   */
  createVinculos: async (usuarioId: number, clienteIds: number[]): Promise<VinculoResponse> => {
    const response = await apiClient.post(`/usuarios/${usuarioId}/clientes`, {
      cliente_ids: clienteIds
    });
    return response.data;
  },

  /**
   * Remove vinculo entre usuario e cliente (soft delete)
   */
  deleteVinculo: async (usuarioId: number, clienteId: number): Promise<VinculoResponse> => {
    const response = await apiClient.delete(`/usuarios/${usuarioId}/clientes/${clienteId}`);
    return response.data;
  },

  /**
   * Atualiza todos os vinculos de um usuario (bulk replace)
   */
  bulkUpdateVinculos: async (usuarioId: number, clienteIds: number[]): Promise<VinculoResponse> => {
    const response = await apiClient.put(`/usuarios/${usuarioId}/clientes/bulk`, {
      cliente_ids: clienteIds
    });
    return response.data;
  },

  /**
   * Lista usuarios que precisam de vinculos mas nao tem nenhum
   */
  getUsuariosSemCliente: async (): Promise<UsuarioSemCliente[]> => {
    const response = await apiClient.get('/usuarios-sem-cliente');
    return response.data;
  },

  /**
   * Lista todos os vinculos usuario-cliente
   */
  getAllVinculos: async (ativo?: boolean) => {
    const params = ativo !== undefined ? { ativo } : {};
    const response = await apiClient.get('/usuarios-clientes', { params });
    return response.data;
  }
};

export default usuarioClienteService;
